export default __webpack_public_path__ + "static/media/bored-babes-banner.9b681880.jpg";